import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';
import { ButtonGroup } from '@@/buttons/ButtonGroup';
import { Button } from '@@/buttons';

export function HostPathItem({
  item,
  onChange,
  index,
}: ItemProps<{ pathPrefix: string; readonly: boolean }>) {
  return (
    <div className="flex gap-2">
      <InputGroup size="small" className="flex-1">
        <InputGroup.Addon>Path</InputGroup.Addon>
        <InputGroup.Input
          type="text"
          className="form-control"
          value={item.pathPrefix}
          onChange={(e) => onChange({ ...item, pathPrefix: e.target.value })}
          data-cy={`allowed-host-path-${index}-input`}
        />
      </InputGroup>
      <ButtonGroup>
        <Button
          color="light"
          size="small"
          className={!item.readonly ? 'active' : ''}
          onClick={() => onChange({ ...item, readonly: false })}
          data-cy={`k8s-constraint-host-path-${index}-writable`}
        >
          Writable
        </Button>
        <Button
          color="light"
          size="small"
          className={item.readonly ? 'active' : ''}
          onClick={() => onChange({ ...item, readonly: true })}
          data-cy={`k8s-constraint-host-path-${index}-readonly`}
        >
          Read-only
        </Button>
      </ButtonGroup>
    </div>
  );
}
